﻿import LfWebService from '../Services/LfWebService';
import camelCase from 'lodash.camelcase';
import queryString from 'query-string';

export default class LoadMoreContentHandler {
    constructor() {
        // attr
        this.buttonAttr = 'lf-load-page';
        this.searchButtonAttr = 'data-lf-search';

        // classes
        this.btnLoadingCl = 'loading';
        this.containerCl = 'listing__container__results';

        // services
        this.lfWebService = new LfWebService(); 

        // constants
        this.minLoaderAnimationTime = 300; 

        this.setupEventListeners(); 
    }

    findSiblings = (el, className) => 
        [...el.parentElement.children].filter(e => e.classList.contains(className)); 

    setupEventListeners = () => {
        let loadMoreBtnEls = document.querySelectorAll(`[data-${this.buttonAttr}]`);

        loadMoreBtnEls.forEach(loadMoreBtnEl => {
            loadMoreBtnEl.addEventListener('click', () => {
                let optQuery = queryString.parse(location.search);
                let currentPage = loadMoreBtnEl.dataset[camelCase(this.buttonAttr)]++;
                let startTime = Date.now(); 

                loadMoreBtnEl.classList.toggle(this.btnLoadingCl);

                const getContent = loadMoreBtnEl.hasAttribute(this.searchButtonAttr)
                    ? this.lfWebService.contentSearchPage
                    : this.lfWebService.contentPage; 

                getContent(currentPage, optQuery.q)
                    .then(result => {
                        let container = this.findSiblings(loadMoreBtnEl, this.containerCl)[0];

                        let timeDiff = Date.now() - startTime;
                        setTimeout(() => {
                            container.innerHTML += result.html;
                            loadMoreBtnEl.classList.toggle(this.btnLoadingCl);

                            if (!result.hasMoreContent) {
                                loadMoreBtnEl.parentNode.removeChild(loadMoreBtnEl); 
                            }
                        }, this.minLoaderAnimationTime - timeDiff); 
                    });                                
            });
        });
    }
}